

const priceReverseCalculator = (nakliyeFiyat, komisyonType, komisyonValue) => {

    let result ;


    if(komisyonType === 1){
        result = (parseInt(nakliyeFiyat) * parseInt(komisyonValue)) / 100
    }

    if(komisyonType === 2){
        result = (parseInt(komisyonValue) / parseInt(nakliyeFiyat)) * 100
    }


  return result
}

export default priceReverseCalculator